import { render, staticRenderFns } from "./ProvideFeedback.vue?vue&type=template&id=0ca6e66d&"
import script from "./ProvideFeedback.vue?vue&type=script&lang=ts&"
export * from "./ProvideFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca6e66d')) {
      api.createRecord('0ca6e66d', component.options)
    } else {
      api.reload('0ca6e66d', component.options)
    }
    module.hot.accept("./ProvideFeedback.vue?vue&type=template&id=0ca6e66d&", function () {
      api.rerender('0ca6e66d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/src/feedback/ProvideFeedback.vue"
export default component.exports